export default "__VITE_ASSET__BRQCwMzR__"